/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */
import KeyValueOrder from "./KeyValueOrder";


interface TableResponse<T> {
  currentPage: number;
  pageCount: number;
  pageSize: number;
  valuesCount: number;
  isServerSide: boolean;
  sortFields: KeyValueOrder[];
  filterFields: KeyValueOrder[];
  values: T[];
}
const TableResponse = {
  create: <T>(initValues?: Partial<TableResponse<T>> | null): TableResponse<T> => {
    const defaults: TableResponse<T> = {
      currentPage: 0,
      pageCount: 0,
      pageSize: 0,
      valuesCount: 0,
      isServerSide: false,
      sortFields: [],
      filterFields: [],
      values: [],
    };
    const fixedValues: Partial<TableResponse<T>> = initValues != null
      ? {
        sortFields: (initValues.sortFields ?? []).map(KeyValueOrder.create) as KeyValueOrder[],
        filterFields: (initValues.filterFields ?? []).map(KeyValueOrder.create) as KeyValueOrder[],
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default TableResponse;
